import isFungible from '@/utils/is-fungible'
import { fungibleInscriptionAmount, isValidTransferOutpoint } from '@/utils/fungible-transfer'
import {
	getInscriptionCollectionSlugs,
	inscriptionBelongsToCollection
} from '@/utils/inscription-collections'
import { isCollectionObjectSlug } from '@/utils/collection-object'

/**
 * Wallet rows the Sell / Send / Split tabs can act on.
 * Fungible rows with a missing amount are dropped so a null `meta` cannot
 * throw while mapping the list (issue #568).
 */
export function selectTokenOutpoints(
	inscriptions: any[] | null | undefined,
	slug: string | undefined,
	objectMemberIds: Set<string> | null
): any[] {
	if (!slug) return []

	return (inscriptions || [])
		.filter((e) => {
			if (slug === 'frozen') return true
			if (slug === 'uncategorized') return getInscriptionCollectionSlugs(e).length === 0
			if (isCollectionObjectSlug(slug)) return objectMemberIds?.has(e.id)
			return inscriptionBelongsToCollection(e, slug)
		})
		.filter((e) => {
			if (isFungible(slug)) return isValidTransferOutpoint(e)
			return true
		})
		.flatMap((e) => {
			const amount = isFungible(slug) ? fungibleInscriptionAmount(e) : 1
			if (amount == null) return []
			return [
				{
					...e,
					inscription_id: e.id,
					amount,
					escrow: e.escrow,
					outpoint: e.id,
					sats: e.outpoint?.sats,
					utxoOutpoint: e.outpoint?.outpoint
				}
			]
		})
}
